import {
  Box,
  Typography,
  Grid,
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';

import type { FallbackProps } from 'react-error-boundary';

const ErrorMessage: React.FC<FallbackProps> = (
  {
    error,
  },
) => (
  <Box m={1}>
    <Grid container>
      <Grid item>
        <Box px={1}>
          <WarningIcon style={{ color: 'red', fontSize: '3rem' }} />
        </Box>
      </Grid>
      <Grid item>
        <Typography variant="h3">{' Something went wrong.'}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1">
          {'Please refresh to resume use of the site. There was the following fatal error with the site:'}
        </Typography>
        <Typography variant="body1">
          {`${error.message}`}
        </Typography>
      </Grid>
    </Grid>
  </Box>
);

export default ErrorMessage;
